<template>
  <div id="app-footer" :style="{backgroundColor: background}">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6 about">
          <h3>About</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p>
          <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut.</p>
          <p>Consectetur adipisicing elit.</p>
        </div>
        <div class="col-md-3 col-sm-6 contact">
          <h3>Contact</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.</p>
          <ul>
            <li><i class="fa fa-map-marker" aria-hidden="true"></i><p>Topanga Canyon</p></li>
            <li><i class="fa fa-envelope" aria-hidden="true"></i><p>office@crs-consulting</p></li>
            <li><i class="fa fa-phone" aria-hidden="true"></i><p>(800) 888-8888</p></li>
          </ul>
        </div>
        <div class="col-md-3 col-sm-6 latest">
          <h3>Latest News</h3>
          <ul>
            <li>
              <i class="fa fa-twitter" aria-hidden="true"></i>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.<br><span>1 hour ago</span></p>
            </li>
            <li>
              <i class="fa fa-twitter" aria-hidden="true"></i>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.<br><span>1 hour ago</span></p>
            </li>
          </ul>
        </div>
        <div class="col-md-3 col-sm-6 news">
          <h3>Newsletter</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.</p>
          <p>Sed do eiusmod tempor incididunt.</p>
          <!-- <br> -->
          <form v-on:submit.prevent="verifyEmail()">
            <div class="input-group">
              <input type="email" class="form-control" placeholder="you@email.com" v-model="email" required>
              <span class="input-group-btn">
                <button class="btn btn-primary" type="submit">Signup</button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="copyright">
      <span>&copy; Copyright. All Rights Reserved CRS-Consulting 2016 - 2017</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'app-footer',
    props: ['background'],
    data () {
      return {
        email: ''
      }
    },
    methods: {
      verifyEmail() {
        let vm = this;
        $.ajax({
          url: 'http://webosoftware.com/static/api.php/newsletter?filter=email,eq,' + vm.email + '&transform=1',
          type: 'GET',
          success: function(res) {
            var exist = (res.newsletter.length == 0) ? false : true;
            if (!exist) {
              $.ajax({
                url: 'http://webosoftware.com/static/api.php/newsletter',
                type: 'POST',
                data: {
                  email: vm.email
                },
                success: function(res) {
                  if (res !== 0) {
                    toastr.success('You are now subscribed to our newsletter.', 'Thank you!');
                    vm.email = '';
                  }
                }
              });
            } else {
              toastr.error('You already subscribed to our newsletter.','Already Subscribed');
            }
          }
        });
      },
    }
  }
</script>

<style scoped lang="sass">
  #app-footer
    color: #ddd
    font-size: .85em
    width: 100%
    text-align: left
    .row
      // width: 1440px
      margin: 0 auto
      padding: 20px 0
      @media screen and (max-width: 992px)
        padding: 50px 0
      &>div
        // max-width: 400px
    .contact
      &>p
        margin-bottom: 16px
    h3
      text-transform: uppercase
      font-size: 1.2em
      letter-spacing: 1px
    ul
      list-style: none
      padding-left: 0
      li
        // line-height: 2em
        // margin-bottom: .2px
        display: flex
        i
          width: 10px
          font-size: 1.5em
          color: #57a4ff
        p
          // display: inline
          margin-left: 20px
          span
            color: #57a4ff
            font-size: .9em
            font-weight: 700
    .input-group
      input
        background: #333
        font-size: 1em
        color: silver
        border: none
      button
        font-size: 12px
        padding: 7.5px 15px

    .copyright
      background: #111
      text-align: center
      padding: 20px
      font-size: 11px
</style>



// WEBPACK FOOTER //
// AppFooter.vue?d89e79c4